"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellMetric = exports.CellType = exports.CellPrice = exports.CellDescription = exports.CellSubHeader = exports.CellHeader = exports.CellBody = exports.Cell = void 0;
const React = require("react");
const Icon_1 = require("../../atoms/Icon");
const Img_1 = require("../../atoms/Img");
const truncateText_1 = require("../../../../helpers/truncateText");
const standardSizes_1 = require("../../../../types/standardSizes");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const Currency_1 = require("../../atoms/Currency");
const Button_1 = require("../../atoms/Button");
const css = (0, cssComposer_1.default)(styles, "cell");
/**
 * Renders a block of content within a card.
 */
const Cell = ({ decorationIcon, decorationImage, isLead, children, hasGoal = false, className = "", actions, onClick = null }) => {
    const hasDecoration = !!(decorationIcon || decorationImage);
    return (React.createElement("div", { className: css("", { "-isLead": isLead, className }), "data-test": "cell", onClick: onClick },
        decorationIcon && (React.createElement(CellDecorationIcon, { isLead: isLead, name: decorationIcon, hasGoal: hasGoal })),
        decorationImage && (React.createElement(CellDecorationImage, { isLead: isLead, url: decorationImage })),
        React.createElement(exports.CellBody, { indent: hasDecoration }, children),
        actions && React.createElement(CellActions, { actions: actions })));
};
exports.Cell = Cell;
const CellDecorationIcon = ({ name, isLead, hasGoal }) => (React.createElement("div", { className: css("decoration"), "data-test": "cell-decoration-icon" },
    React.createElement(Icon_1.Icon, { name: name, className: css("decoration_icon", {
            "-isLead": isLead
        }) }),
    hasGoal ? React.createElement(Icon_1.Icon, { name: "goal", className: css("goal") }) : null));
const CellDecorationImage = ({ url, isLead }) => (React.createElement("div", { className: css("decoration"), "data-test": "cell-decoration-image" },
    React.createElement(Img_1.Img, { src: url, className: css("decoration_img", {
            "-isLead": isLead
        }) })));
const CellBody = ({ indent = false, children }) => (React.createElement("div", { className: css("body", { "-indent": indent }), "data-test": "content" }, children));
exports.CellBody = CellBody;
const CellHeader = ({ children }) => (React.createElement("h4", { className: css("header"), "data-test": "cell-header" }, children));
exports.CellHeader = CellHeader;
const CellSubHeader = ({ children }) => (React.createElement("h5", { className: css("header-small"), "data-test": "cell-header-small" }, children));
exports.CellSubHeader = CellSubHeader;
const CellDescription = ({ truncate = false, className = "", children }) => {
    return (React.createElement("div", { className: css("description", { className }), "data-test": "cell-description" }, truncate && typeof children === "string"
        ? (0, truncateText_1.truncateText)(children)
        : children));
};
exports.CellDescription = CellDescription;
const CellPrice = ({ price, quantity, children }) => {
    return (React.createElement("h4", null,
        children,
        " - ",
        React.createElement(Currency_1.Currency, null, price),
        " ",
        React.createElement("strong", null, quantity ? "x" + quantity : null)));
};
exports.CellPrice = CellPrice;
const CellType = ({ icon, children }) => (React.createElement("div", { "data-test": "cell-type", className: css("type") },
    icon && (React.createElement("div", { "data-test": "icon" },
        React.createElement(Icon_1.Icon, { name: icon, size: standardSizes_1.TStandardSizes.Small, className: css("type_icon") }))),
    children && (React.createElement("div", { "data-test": "label" },
        React.createElement("label", null, children)))));
exports.CellType = CellType;
/**
 * Used to exaggerate a value and associate a label with that value.
 */
const CellMetric = ({ value, label }) => {
    return (React.createElement("div", { "data-test": "metric", className: css("metric") },
        React.createElement("span", { "data-test": "value", className: css("metric_value") }, value),
        React.createElement("span", { "data-test": "label", className: css("metric_label") }, label)));
};
exports.CellMetric = CellMetric;
const CellActions = ({ actions, isLead }) => {
    return (React.createElement("div", { className: css("actions"), "data-test": "actions" }, actions.map((action, i) => (React.createElement("span", { "data-test": `action-${i}`, key: i, className: css("actions_action") },
        !!action.icon && (React.createElement("div", { className: css("actions_action_icon") },
            React.createElement(Icon_1.Icon, { size: standardSizes_1.TStandardSizes.ExtraSmall, name: action.icon, onClick: typeof action.onClick === "function" ? action.onClick : null }))),
        !!action.label && (React.createElement("div", { className: css("actions_action_button"), "data-test": `action-${i}-button` },
            React.createElement(Button_1.Button, { onClick: typeof action.onClick === "function" ? action.onClick : null }, action.label))))))));
};
//# sourceMappingURL=index.js.map